
import { CustomSuggestionSectionModel } from "@BrasselerSurgical/Types/SuggestionModel";
import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";



export interface SuggestionApiParameter extends ApiParameter {
    query: string;
    pageSize?: number;
    page?: number;
    brandEnabled?: boolean;
    categoryEnabled?: boolean;
    contentEnabled?: boolean;
    productEnabled?: boolean;
    spireContent?: boolean;
    searchOnTyping?: boolean;
}

const suggestionUrl = "/api/v1/searchsuggestion";

export function getSearchSuggestions(
    parameter: SuggestionApiParameter & HasOnSuccess<CustomSuggestionSectionModel> & HasOnComplete<CustomSuggestionSectionModel>,
) {
    const apiParameter = { ...parameter, spireContent: true };
    delete apiParameter.onSuccess;
    delete apiParameter.onComplete;    
    return get<CustomSuggestionSectionModel>(suggestionUrl, apiParameter);
}

